import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer id="fot">
      <p>© {new Date().getFullYear()} · Portfolio de Tomas Ninno</p>
    </footer>
  );
};

export default Footer;
